module.exports = __webpack_public_path__ + "img/Sandemose_Jantelov_og_varulver.adfc0ce4.jpg";